/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Table_StatusInputs */

const id_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const ms_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const da_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const de_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const en_us2_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const es_es2_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const es_mx2_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const fil_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katayuan`)
};

const fr_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut`)
};

const it_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato`)
};

const hu_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Állapot`)
};

const nl_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const no_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const pl_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const pt_br2_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const pt_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const ro_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stare`)
};

const fi_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tila`)
};

const sv_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const vi_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trạng thái`)
};

const tr_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durum`)
};

const cs_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav`)
};

const bg_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус`)
};

const ru_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус`)
};

const uk_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус`)
};

const ar_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحالة`)
};

const hi_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति`)
};

const th_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถานะ`)
};

const ja_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ステータス`)
};

const zh_cn2_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状态`)
};

const zh_hant1_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`狀態`)
};

const ko_items_table_status = /** @type {(inputs: Items_Table_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상태`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Items_Table_StatusInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_table_status = /** @type {((inputs?: Items_Table_StatusInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Table_StatusInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_table_status(inputs)
	if (locale === "ms") return ms_items_table_status(inputs)
	if (locale === "da") return da_items_table_status(inputs)
	if (locale === "de") return de_items_table_status(inputs)
	if (locale === "en-US") return en_us2_items_table_status(inputs)
	if (locale === "es-ES") return es_es2_items_table_status(inputs)
	if (locale === "es-MX") return es_mx2_items_table_status(inputs)
	if (locale === "fil") return fil_items_table_status(inputs)
	if (locale === "fr") return fr_items_table_status(inputs)
	if (locale === "it") return it_items_table_status(inputs)
	if (locale === "hu") return hu_items_table_status(inputs)
	if (locale === "nl") return nl_items_table_status(inputs)
	if (locale === "no") return no_items_table_status(inputs)
	if (locale === "pl") return pl_items_table_status(inputs)
	if (locale === "pt-BR") return pt_br2_items_table_status(inputs)
	if (locale === "pt") return pt_items_table_status(inputs)
	if (locale === "ro") return ro_items_table_status(inputs)
	if (locale === "fi") return fi_items_table_status(inputs)
	if (locale === "sv") return sv_items_table_status(inputs)
	if (locale === "vi") return vi_items_table_status(inputs)
	if (locale === "tr") return tr_items_table_status(inputs)
	if (locale === "cs") return cs_items_table_status(inputs)
	if (locale === "bg") return bg_items_table_status(inputs)
	if (locale === "ru") return ru_items_table_status(inputs)
	if (locale === "uk") return uk_items_table_status(inputs)
	if (locale === "ar") return ar_items_table_status(inputs)
	if (locale === "hi") return hi_items_table_status(inputs)
	if (locale === "th") return th_items_table_status(inputs)
	if (locale === "ja") return ja_items_table_status(inputs)
	if (locale === "zh-CN") return zh_cn2_items_table_status(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_table_status(inputs)
	return ko_items_table_status(inputs)
});
export { items_table_status as "items.table.status" }